/*
  Create Your Piece — progress (10A.07: "the five-step rail, desktop and mobile").
  Desktop rail: upcoming / active / complete ("{value} · Edit").
  Mobile block: "STEP n OF 5", the step name and a 2px track.
  Announces each committed step politely.
*/
(function () {
  'use strict';
  var CYP = window.PersonaCYP;
  if (!CYP) return;

  CYP.use(function (cyp) {
    var root = cyp.root;
    var slots = root.querySelectorAll('[data-rail]');
    var mN = root.querySelector('[data-mprog-n]');
    var mName = root.querySelector('[data-mprog-name]');
    var mFill = root.querySelector('[data-mprog-fill]');
    var WORDS = ['No', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight'];

    function num(st) { return st === '4b' ? 4 : parseInt(st, 10) || 0; }

    function values(s) {
      var pc = cyp.pieceBy(s);
      var sp = cyp.sportBy(s.sport);
      var fe = s.finish ? cyp.finishEntry(s) : null;
      var eng = '';
      if (s.type === 'none') eng = 'None';
      else if (s.type === 'text') eng = s.value || '';
      else if (s.type === 'crest') eng = 'Crest';
      return {
        1: sp ? sp.name : '',
        2: pc ? cyp.settings.short[pc.family] : '',
        3: fe ? fe.label : '',
        4: eng,
        5: ''
      };
    }

    function done(i, s) {
      var land = cyp.landing();
      var order = ['0', '1', '2', '3', '4', '4b', '5'];
      var need = { 1: '2', 2: '3', 3: '4', 4: '5', 5: '6' }[i];
      return order.indexOf(land) >= order.indexOf(need) || (i === 4 && land === '5');
    }

    function render() {
      var s = cyp.state;
      var cur = num(cyp.step);
      var v = values(s);
      slots.forEach(function (slot) {
        var i = parseInt(slot.getAttribute('data-rail'), 10);
        var complete = i !== cur && i < 5 && done(i, s) && v[i];
        if (cyp.step === '5' && i < 5) complete = !!v[i];
        slot.classList.toggle('is-active', i === cur);
        slot.classList.toggle('is-next', cur === 0 && i === 1);
        slot.classList.toggle('is-complete', !!complete);
        slot.querySelector('[data-rail-val]').textContent = complete ? v[i] : '';
        var status = slot.querySelector('[data-rail-status]');
        status.textContent = i === cur ? ', current step' : complete ? ', complete: ' + v[i] : '';
        if (i === cur) slot.setAttribute('aria-current', 'step'); else slot.removeAttribute('aria-current');
      });
      if (mN) mN.textContent = cur ? 'Step ' + cur + ' of 5' : '';
      if (mName) mName.textContent = cur ? cyp.STEP_NAMES[cur] : '';
      if (mFill) mFill.style.width = (cur ? cur * 20 : 0) + '%';
    }

    function announceStep() {
      var cur = num(cyp.step);
      if (!cur) return;
      var s = cyp.state;
      var sp = cyp.sportBy(s.sport);
      var line = 'Step ' + cur + ' of 5. ';
      if (cur === 1) line += 'Choose your sport.';
      if (cur === 2) {
        line += 'Choose your piece.';
        if (sp) line += ' ' + WORDS[sp.pieces.length] + ' ' + sp.name + (sp.pieces.length === 1 ? ' piece' : ' pieces') + ' available.';
      }
      if (cur === 3) line += 'Choose your finish.';
      if (cur === 4) line += cyp.step === '4b' ? (s.type === 'crest' ? 'Send us your crest.' : 'Type your engraving and choose a style.') : 'Choose how to personalize it.';
      if (cur === 5) return; // the reveal announces the full configuration itself
      cyp.announce(line);
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rail-edit]');
      if (!b) return;
      var i = b.getAttribute('data-rail-edit');
      var field = { 1: 'sport', 2: 'piece', 3: 'finish', 4: 'personalization' }[i];
      cyp.track('edit_clicked', { field: field, from_step: cyp.step });
      cyp.emit('edit', { field: field, from_step: cyp.step });
      cyp.go(i === '4' && (cyp.state.type === 'text' || cyp.state.type === 'crest') ? '4' : String(i));
    });

    cyp.on('state', render);
    cyp.on('step', function (d) {
      render();
      if (!d.initial) announceStep();
    });
  });
})();
